// Scored-calls table as a widget: a thin scoping wrapper around the
// same ScoredCallsBrowser the entity drawers use.
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Card } from '@/components/cards/Card'

import { ScoredCallsBrowser } from '../drawers/ScoredCallsBrowser'
import { useDashboardOrgId, useFiltersForPickedScope } from '../helpers/dashboardParams'

export const ScoredCallsWidget = ({ scope }) => {
  const orgId = useDashboardOrgId()
  const filters = useFiltersForPickedScope(scope)
  const appliedCallType = useSelector((state) => state.qaCopilot.data?.appliedCallType)

  // ScoredCallsBrowser reads its own filters via scopeFilters -- forward
  // the whole picker-narrowed filter set so the widget stays in sync with
  // the scope tab (agent picked -> agent's calls, etc.) AND with every
  // filter-bar dimension. Spread rather than enumerate: buildDashboardParams
  // only reads the keys it knows, so a new filter (e.g. scoredStatus) flows
  // through automatically instead of silently dropping off. Matches the
  // entity-drawer path, which already spreads the full filter object.
  const scopeFilters = useMemo(
    () => ({ ...(filters || {}), callType: appliedCallType }),
    [filters, appliedCallType]
  )

  return (
    <Card
      className="scored-calls-widget"
      title="Call scores"
      info="Each row is one call's score on one scorecard. A call scored on multiple scorecards appears once for each, so there can be more rows here than calls."
    >
      <ScoredCallsBrowser scopeFilters={scopeFilters} orgId={orgId} />
    </Card>
  )
}
